import React from "react";

import Custom404 from "src/pages/404";
import PageWrapper from "@/components/PageWrapper";
import MetaHead from "@/components/MetaHead";
import Container from "@/components/Container";
import Typography from "@/components/Typography";
import AuthorTile from "@/components/AuthorTile";
import Recommended from "@/components/Recommended";
import { GridColumns } from "@/components/Container/Container.interface";
import { AuthorsPageInterface } from "@/helpers/pageHelpers/Author/interface";
import { apiPath } from "@/helpers/apiPath";
import useRequest from "@/helpers/useRequest";
import { apiClient } from "@/helpers/apiClient";
import AuthorTopAd from "@/components/Advertisement/AuthorTop";
import AuthorBottomAd from "@/components/Advertisement/AuthorBottom";
import AuthorSidebarAd from "@/components/Advertisement/AuthorSidebar";
import { authorsdMetaData } from "@/helpers/pageMetaData";

import styles from "./Authors.module.scss";

export const Authors: React.FC<AuthorsPageInterface> = ({
  seo,
  initialData,
}) => {
  const { data: authors, error } = useRequest(apiPath.REDACTORS, {
    initialData,
    revalidateOnMount: true,
  });

  const metaData = {
    ...seo,
    ...authorsdMetaData,
  };

  const pageDate = {
    headerLabel: "Redakcja",
  };

  if (!initialData || error || authors?.error) {
    return <Custom404 />;
  }

  return (
    <PageWrapper pageData={pageDate}>
      <MetaHead metaData={metaData} />

      <div className={styles.top}>
        <Container>
          <Typography variant="hero" component="h3" className={styles.heading}>
            <span>Redaktorzy</span>

            <Typography variant="h3" className={styles.count}>
              {authors.length}
            </Typography>
          </Typography>
        </Container>
      </div>

      <Container>
        <AuthorTopAd />
      </Container>

      <Container grid={GridColumns.Three}>
        <div className={styles.list}>
          {authors?.map((author) => (
            <AuthorTile key={author.slug} {...author} />
          ))}
        </div>

        <div className={styles.display}>
          <AuthorSidebarAd />
        </div>
      </Container>

      <Container>
        <AuthorBottomAd />
      </Container>

      <Recommended />
    </PageWrapper>
  );
};

export async function getStaticProps() {
  const client = apiClient();

  const { data } =
    (await client.get(apiPath.REDACTORS, {
      validateStatus: () => true,
    })) || {};
  const { data: seo } =
    (await client.get(apiPath.SEO, {
      validateStatus: () => true,
    })) || {};

  return {
    props: {
      seo,
      initialData: data,
    },
    revalidate: 86400,
  };
}

export default Authors;
